import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './LandingSections.css';

gsap.registerPlugin(ScrollTrigger);

const Stats = () => {
  const sectionRef = useRef(null);
  const statItemsRef = useRef([]);

  useEffect(() => {
    const section = sectionRef.current;
    const statItems = statItemsRef.current;

    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: 'top 85%',
        end: 'bottom 20%',
        once: true,
      },
    });

    statItems.forEach((item, index) => {
      const numberEl = item.querySelector('h3');
      const targetText = numberEl.textContent;
      const targetNumber = parseInt(targetText.replace(/[^0-9]/g, ''));

      const counter = { value: 0 };

      // Animate number with scale 0 to 1 and count up
      timeline.fromTo(
        numberEl,
        {
          scale: 0
        },
        {
          scale: 1,
          duration: 0.6,
          ease: 'back.out(1.7)', // Creates overshoot/bounce effect
        },
        index * 0.2 // Stagger delay between numbers
      );

      // Animate number counting up
      timeline.to(
        counter,
        {
          value: targetNumber,
          duration: 1.5,
          ease: 'power2.out',
          onUpdate: () => {
            numberEl.textContent = `${Math.round(counter.value)}+`;
          },
        },
        index * 0.2 + 0.3 // Start counting shortly after scale animation
      );
    });

  }, []);

  return (
    <section className="stats-section" ref={sectionRef}>
      <div className="container">
        <div className="stat-item" ref={(el) => (statItemsRef.current[0] = el)}>
          <h3>500+</h3>
          <p>students trained</p>
        </div>
        <div className="stat-item" ref={(el) => (statItemsRef.current[1] = el)}>
          <h3>15+</h3>
          <p>schools trained</p>
        </div>
        <div className="stat-item" ref={(el) => (statItemsRef.current[2] = el)}>
          <h3>20+</h3>
          <p>medals won by students</p>
        </div>
      </div>
    </section>
  );
};

export default Stats;
